import { Model } from "pinia-orm";
import QuestionnaireSessionQuestion from "@/models/QuestionnaireSessionQuestion";

export default class Answer extends Model {
  static entity = "answers";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      updateAt: this.string(""),
      createdAt: this.string(""),
      createdBy: this.string(""),
      modifiedBy: this.string(""),
      questionnaireSessionQuestionUuid: this.string(""),
      questionnaireSessionQuestionData: this.belongsTo(
        QuestionnaireSessionQuestion,
        "questionnaireSessionQuestionUuid",
      ),
      text: this.string(""),
      choices: this.attr([]),
      score: this.number(null),
      isDisplayed: this.boolean(true),
    };
  }
}
